import { chartColor } from 'Helpers/chartService'
import React, { useEffect } from 'react'
import { useIntl } from 'react-intl'
import { useParams } from 'react-router-dom'

import {
  STORE_KEY_ACCOUNT_DATA_RETENTION,
  storeGet,
} from 'mailup-react-helpers'
import { useRecoilCallback, useRecoilValue } from 'recoil'
import { laodTrendChartCallback } from '../recoil/callbacks/callbacks'

import { chartState } from '../recoil/state/result'

import {
  Panel,
  SingleLoader,
  TITLE_VARIANT_L,
  Title,
} from 'mailup-web-components'
import AreaChart from '../components/AreaChart'

const TrendChart = () => {
  const intl = useIntl()
  const laodTrendChart = useRecoilCallback(laodTrendChartCallback, [])
  const chart = useRecoilValue(chartState)
  const { idRecipient } = useParams()
  const dataRetention = storeGet(STORE_KEY_ACCOUNT_DATA_RETENTION)

  useEffect(() => {
    laodTrendChart(Number.parseInt(idRecipient))
  }, [])

  const styleSeriesChart = [
    {
      label: intl.formatMessage({ id: 'Load.ActiveRecipientTrend.Opens' }),
      fill: chartColor.LightblueZeroFill,
      stroke: chartColor.LightblueZero,
      strokeOpacity: 0.69,
      iconFill: chartColor.LightblueZero,
    },
    {
      label: intl.formatMessage({ id: 'Load.ActiveRecipientTrend.Clicks' }),
      fill: chartColor.AcquamarineOneFill,
      stroke: chartColor.AcquamarineOne,
      strokeOpacity: 0.52,
      iconFill: chartColor.AcquamarineOne,
    },
  ]

  return (
    <Panel>
      {chart.loading && <SingleLoader height="394px" />}
      {chart.dailyCounters.length > 0 && !chart.loading && (
        <>
          <Title variant={TITLE_VARIANT_L} textAlign="center">
            {intl.formatMessage(
              { id: 'Load.ActiveRecipientTrend.TitleChart' },
              { x: dataRetention },
            )}
          </Title>
          <AreaChart
            style={{ height: '394px' }}
            data={chart.dailyCounters}
            styleSeriesChart={styleSeriesChart}
          />
        </>
      )}
    </Panel>
  )
}

export default TrendChart
